/**
 * Project: fuse-react-app
 * FilePath: /src/client/app/sectors/Table/store/reducers/index.js
 * File: index.js
 * Created Date: Friday, January 11th 2019, 9:58:14 am
 * Author: Craig Bojko (craig.bojko@anexsys.com)
 * -----
 * Last Modified: Sun Jan 27 2019
 * Modified By: Craig Bojko
 * -----
 * Copyright (c) 2019 Anexsys
 * ------------------------------------
 */

// import { combineReducers } from 'redux'
import projectsReducer from './projects.reducer'

// const reducers = combineReducers({
//   projectsReducer
// })

// export default reducers

export default projectsReducer
